// extracted by mini-css-extract-plugin
export default {"timeline":"timeline__fLiP5","timeline-container":"timeline-container__fhBFT","progress":"progress__czy0Y","time":"time__6XfRf"};